import React, {useEffect, useState} from 'react'
import UserForm from "./UserForm";
import {useParams} from "react-router";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import AsyncBlock from "../../components/forms/AsyncBlock";
import {errorToast, successToast} from "../../components/layout/ToastStyles";
import {Apis} from "../../util/data";
import PageContainer from "../../components/layout/PageContainer";
import PageSection from "../../components/layout/PageSection";
import {PageBackLabel} from "../../components/layout/PageBackLabel";
import PageTitle from "../../components/layout/PageTitle";
import useFetch2 from "../../hooks/useFetch2";
import {format} from "date-fns";

const UserEdit = () => {

  const navigate = useNavigate()

  const {id} = useParams()
  const {data, loading, fetchData, error} = useFetch2(Apis.PROD + '/usuario/' + id, {});

  const [formatedData,setFormatedData] = useState(null)

  useEffect(()=>{
    if(data && data.fechaNacimiento){
      setFormatedData({...data,fechaNacimiento: format(new Date(data.fechaNacimiento), 'yyyy-MM-dd')})
    }
  },[data])

  const onUpdate = (user) => {
    user.fechaNacimiento = user.fechaNacimiento + "T00:00:00-05:00";
    axios.put(Apis.PROD + '/usuario/update/' + id, user)
      .then(res => {
        successToast("Usuario actualizado correctamente")
        navigate('/usuarios')
      })
      .catch(err => {
        errorToast(err.response.data.message, 6000)
      });
  }

  return (
    <PageContainer>
      <PageSection>
        <PageBackLabel text='Usuarios' onClick={() => navigate('/usuarios')}/>
        <PageTitle title={data.nombres}/>
      </PageSection>

      <PageSection>
        <AsyncBlock loading={loading} error={error}>
          <UserForm value={formatedData} onSubmit={(user) => onUpdate(user)}/>
        </AsyncBlock>

      </PageSection>
    </PageContainer>
  )
}

export default UserEdit;
